module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs/export_pdf.png?bef3a085ac4b94005a10276a3c8e68a9";